/* eslint-disable no-param-reassign, no-unused-vars, no-useless-escape */
import angular from 'angular';
import moment from 'moment';

import * as actions from '../../../store/actions';

const mapStateToScope = (state) => ({
  records: state.user.users,
  subComponent: state.statsbar.activeComponent,
  tableInfo: state.table.tableInfo,
});

/**
 * @ngdoc function
 * @name myConsultApp.controller:table
 * @description
 * # table
 * Controller of the myConsultApp
 */
angular
  .module('myConsultApp')
  .controller('adminTableController', ($http, ENV, $ngRedux, $scope, $rootScope, $timeout) => {
    // init variables
    const PREVENT_SEARCH_PARAM_ENDPOINTS = ['user-activities'];
    $scope.enableTableActionMenu = false;
    $scope.initialLoad = true;
    $scope.isPageOptions = false;
    $scope.isSortOptions = false;
    $scope.isTableActionMenu = false;
    $scope.pageData = {};
    $scope.records = [];
    $scope.searchTerm = null;
    $scope.showMoreStatus = {};
    $scope.tableLoading = false;
    $scope.isUserPageLoaded = false;
    $scope.isFilterValid = true;
    $scope.init = () => {
      $scope.unsubscribe = $ngRedux.connect(mapStateToScope, actions)($scope);
    };

    $scope.format_timeframe_range = (from, to) => {
      if (from) {
        const date = moment(from);
        from = date.isValid() ? date.format('YYYY-MM-DD') : from;
      }
      if (to) {
        const date = moment(to);
        to = date.isValid() ? date.format('YYYY-MM-DD') : to;
      }
      return [from, to];
    };

    $scope.checkTableActionsDisplay = () => {
      $scope.enableTableActionMenu = false;
      angular.forEach($scope.table.actions, (action) => {
        if (!action.superuser || (action.superuser && $rootScope.isSuperUser)) {
          $scope.enableTableActionMenu = true;
        }
      });
    };

    $scope.checkRangeErrors = async (filter_key, choice_key, date_field, submission) => {
      if (!$scope.table.filters[filter_key].options.choices[choice_key].state) {
        $scope.table.filters[filter_key].options.choices[choice_key].from = '';
        $scope.table.filters[filter_key].options.choices[choice_key].to = '';
      } else {
        if (submission) {
          if (
            !$scope.table.filters[filter_key].options.choices[choice_key].from ||
            !$scope.table.filters[filter_key].options.choices[choice_key].to ||
            $scope.table.filters[filter_key].options.choices[choice_key].from === '' ||
            $scope.table.filters[filter_key].options.choices[choice_key].to === ''
          ) {
            $scope.table.filters[filter_key].options.choices[choice_key].error = true;
            return true;
          }
        }

        if (
          !$scope.table.filters[filter_key].options.choices[choice_key].from ||
          !$scope.table.filters[filter_key].options.choices[choice_key].to ||
          $scope.table.filters[filter_key].options.choices[choice_key].from === '' ||
          $scope.table.filters[filter_key].options.choices[choice_key].to === ''
        ) {
          return true;
        }

        let from = null;
        let to = null;

        if (date_field) {
          from = moment(
            $scope.table.filters[filter_key].options.choices[choice_key].from,
          ).valueOf();
          to = moment($scope.table.filters[filter_key].options.choices[choice_key].to).valueOf();
        } else {
          from = $scope.table.filters[filter_key].options.choices[choice_key].from;
          to = $scope.table.filters[filter_key].options.choices[choice_key].to;
        }

        if (to - from < 0) {
          $scope.table.filters[filter_key].options.choices[choice_key].error = true;
          return true;
        }

        $scope.table.filters[filter_key].options.choices[choice_key].error = false;
        return false;
      }
    };

    $scope.watch_timeframe_range = async (filter_key, choice_key, target) => {
      if (!$scope.table.filters[filter_key].options.choices[choice_key].state) {
        $scope.table.filters[filter_key].options.choices[choice_key].from = '';
        $scope.table.filters[filter_key].options.choices[choice_key].to = '';
      } else {
        const timeframe = await $scope.format_timeframe_range(
          $scope.table.filters[filter_key].options.choices[choice_key].from,
          $scope.table.filters[filter_key].options.choices[choice_key].to,
        );
        $scope.table.filters[filter_key].options.choices[choice_key].from = timeframe[0];
        $scope.table.filters[filter_key].options.choices[choice_key].to = timeframe[1];
        if (
          $scope.table.filters[filter_key].options.choices[choice_key][target] &&
          $scope.table.filters[filter_key].options.choices[choice_key][target] !== ''
        ) {
          await angular.forEach(
            $scope.table.filters[filter_key].options.choices,
            async (choice, key) => {
              $scope.table.filters[filter_key].options.choices[key].state = key === choice_key;
            },
          );
        }
      }
    };
    angular.forEach($scope.table.filters, async (filter, filter_key) => {
      if (filter.type === 'date_range') {
        const { options } = filter;

        const watchHandler = async () => {
          const [from, to] = await $scope.format_timeframe_range(
            options.from.value,
            options.to.value,
          );

          options.from.value = from;
          options.to.value = to;

          $scope.validateFilters();
        };

        $scope.$watch(`table.filters[${filter_key}].options.from.value`, watchHandler);
        $scope.$watch(`table.filters[${filter_key}].options.to.value`, watchHandler);
      }

      angular.forEach(filter.options.choices, async (choice, choice_key) => {
        if ('from' in choice) {
          $scope.$watch(
            `table.filters[${filter_key}].options.choices['${choice_key}'].from`,
            async () => {
              if (choice.date_field) {
                await $scope.watch_timeframe_range(filter_key, choice_key, 'from');
              }
            },
          );
        }
        if ('to' in choice) {
          $scope.$watch(
            `table.filters[${filter_key}].options.choices['${choice_key}'].to`,
            async () => {
              if (choice.date_field) {
                await $scope.watch_timeframe_range(filter_key, choice_key, 'to');
              }
            },
          );
        }
      });
    });

    // Angucomplete Filter

    $scope.filterAngucomplete = (query, key) => {
      if ($scope.table.filters[key].options.search_endpoint !== undefined) {
        return $scope
          .angucompleteSearch(
            $http,
            ENV,
            $scope.table.filters[key].options.search_endpoint,
            $scope.table.filters[key].options.search_endpoint_data_key,
            { search: query, autocomplete: true },
          )
          .then((res) => res);
      }

      return $scope[$scope.table.filters[key].angucomplete_parameters.searchfn](query);
    };

    $scope.filterAngucompletePage = (query, key) => {
      return $scope
        .angucompleteSearchByUrl(
          $http,
          query,
          $scope.table.filters[key].options.search_endpoint_data_key,
        )
        .then((res) => res);
    };

    $scope.setSelectedAngucomplete = (item, key) => {
      $scope.table.filters[key].options.selected.push(item);
    };

    $scope.removeAngucomplete = (id, key) => {
      $scope.table.filters[key].options.selected = $scope.table.filters[
        key
      ].options.selected.filter((item) => item.id !== id);
    };

    $scope.removeAllAngucomplete = (key) => {
      $scope.table.filters[key].options.selected = [];
    };

    $scope.change_timeframe = async (new_timeframe_choice) => {
      await angular.forEach($scope.table.filters, async (filter, filter_key) => {
        if (filter.options.query_string_parameter === 'timeframe') {
          await angular.forEach(filter.options.choices, async (choice, choice_key) => {
            if (choice.value === new_timeframe_choice) {
              $scope.table.filters[filter_key].options.choices[choice_key].state = true;
            } else {
              $scope.table.filters[filter_key].options.choices[choice_key].state = false;
            }
          });
        }
      });
    };

    $rootScope.clearSearchTerm = () => {
      $scope.searchTerm = null;
    };

    // Get Table Data
    $rootScope.getData = async (keepPage = false) => {
      if ($scope.table.options.search_required && !$scope.searchTerm) {
        return;
      }
      $scope.tableLoading = true;

      let parameters = {};

      await angular.forEach($scope.table.filters, async (filter, key) => {
        if (filter.type === 'text_input') {
          parameters[filter.options.query_string_parameter] = filter.options.selected;
        }
        if (filter.type === 'multiple_choice') {
          parameters[filter.options.query_string_parameter] = Object.values(filter.options.choices)
            .filter((item) => item.state === true)
            .map((item) => item.value)
            .join(',');
          if (
            (!(filter.options.query_string_parameter in parameters) ||
              parameters[filter.options.query_string_parameter] === '') &&
            'no_selected_parameter' in filter.options
          ) {
            parameters[filter.options.query_string_parameter] =
              filter.options.no_selected_parameter;
          }

          if (filter.options.query_string_parameter == 'missing_points') {
            if (filter.options.choices['Only Missing Points History Activities'].state) {
              $scope.table.options.isMissingPoints = true;
            } else {
              $scope.table.options.isMissingPoints = false;
            }
          }
        }
        if (filter.type === 'multi_level_multiple_choice') {
          let multi_level_selected = [];
          await Object.entries(filter.options.choices).forEach(async ([choice_key, choice]) => {
            if (choice.state === true) {
              if ('options' in choice) {
                let options = '';
                await angular.forEach(choice.options, async (level, level_key) => {
                  if (level.state) {
                    options = `${options}:${level.value}`;
                  }
                });
                if (options !== '') {
                  multi_level_selected.push(`${choice.value}${options}`);
                }
              }
            }
          });
          if (multi_level_selected.length) {
            parameters[filter.options.query_string_parameter] = multi_level_selected.join(',');
          }
        }
        if (filter.type === 'single_choice') {
          await Object.entries(filter.options.choices).forEach(async ([choice_key, choice]) => {
            if ('error' in $scope.table.filters[key].options.choices[choice_key]) {
              $scope.table.filters[key].options.choices[choice_key].error = false;
            }
            if (choice.state === true) {
              if (choice.type === 'standard') {
                parameters[filter.options.query_string_parameter] = choice.value;
              } else if (choice.type === 'amount') {
                if (!choice.amount || choice.amount === '') {
                  $scope.table.filters[key].options.choices[choice_key].error = true;
                } else {
                  parameters[
                    filter.options.query_string_parameter
                  ] = `${choice.value}:${choice.amount}`;
                }
              } else if (choice.type === 'range') {
                if (choice.date_field) {
                  const formatted_dates = await $scope.format_timeframe_range(
                    choice.from,
                    choice.to,
                  );
                  let date = null;
                  if (formatted_dates[0] && formatted_dates[0] !== '') {
                    date = moment(formatted_dates[0]);
                    $scope.table.filters[key].options.choices[choice_key].to = date.isValid()
                      ? date.format('YYYY-MM-DD')
                      : null;
                  }
                  if (formatted_dates[1] && formatted_dates[1] !== '') {
                    date = moment(formatted_dates[1]);
                    $scope.table.filters[key].options.choices[choice_key].to = date.isValid()
                      ? date.format('YYYY-MM-DD')
                      : null;
                  }
                  if (
                    $scope.table.filters[key].options.choices[choice_key].from &&
                    $scope.table.filters[key].options.choices[choice_key].to
                  ) {
                    const areErrors = await $scope.checkRangeErrors(
                      key,
                      choice_key,
                      choice.date_field,
                      true,
                    );
                    if (!areErrors) {
                      parameters[
                        filter.options.query_string_parameter
                      ] = `range:${choice.from}:${choice.to}`;
                    }
                  } else {
                    $scope.table.filters[key].options.choices[choice_key].error = true;
                  }
                } else if (choice.to && choice.from) {
                  const areErrors = await $scope.checkRangeErrors(
                    key,
                    choice_key,
                    choice.date_field,
                    true,
                  );
                  if (!areErrors) {
                    parameters[
                      filter.options.query_string_parameter
                    ] = `${choice.value}:${choice.from}:${choice.to}`;
                  }
                } else {
                  $scope.table.filters[key].options.choices[choice_key].error = true;
                }
              }
            }
          });
        }
        if (filter.type === 'angucomplete') {
          if (filter.options.selected.length) {
            parameters[
              filter.options.query_string_parameter
            ] = filter.options.selected
              .map((item) =>
                filter.options.selected_parameter
                  ? item[filter.options.selected_parameter]
                  : item.id,
              )
              .join(',');
          }
        }

        if (filter.type === 'date_range') {
          const { from, to } = filter.options;

          if (from.value) {
            parameters[from.query_string_parameter] = from.value;
          }

          if (to.value) {
            parameters[to.query_string_parameter] = to.value;
          }
        }
      });

      let error = false;
      await angular.forEach($scope.table.filters, async (filter, key) => {
        if (filter.type === 'single_choice') {
          await Object.entries(filter.options.choices).forEach(async ([choice_key, choice]) => {
            if (
              'error' in $scope.table.filters[key].options.choices[choice_key] &&
              $scope.table.filters[key].options.choices[choice_key].error
            ) {
              error = true;
            }
          });
        }
      });
      if (error) {
        $scope.tableLoading = false;
        return;
      }
      $scope.records = [];
      const sortOptions = [];
      await Object.entries($scope.table.sort_options).forEach(([key, item]) => {
        if (item.state === true) {
          sortOptions.push(item.value === '1' ? key : `-${key}`);
        }
      });
      parameters.order = sortOptions.join(',');
      if (
        keepPage &&
        $scope.pageData &&
        $scope.pageData.meta &&
        $scope.pageData.meta.current_page
      ) {
        parameters.page = $scope.pageData.meta.current_page;
      } else {
        $scope.pageData = {};
      }
      parameters.page_size = $scope.table.options.records_per_page;
      if ($scope.searchTerm) {
        parameters.search = $scope.searchTerm;
      }
      if (angular.element('#searchQuery').val() !== $scope.searchTerm) {
        $rootScope.$broadcast('updateAdminSearchQuery');
        parameters.search = angular.element('#searchQuery').val();
      }
      // unset parameters.search for when endpoint shouldn't accept search term
      if (
        PREVENT_SEARCH_PARAM_ENDPOINTS.contains($scope.table.options.endpoint_data_key) &&
        $scope.table.options.id_prefix === 'userprofile'
      ) {
        delete parameters.search;
      }
      if ($scope.table.options.endpoint_data_key === 'users') {
        $scope.setTableDataInfo({
          filters: angular.copy($scope.table.filters),
          sort_options: angular.copy($scope.table.sort_options),
          search_term: $scope.searchTerm,
          page_size: $scope.table.options.records_per_page,
        });
      }
      $scope
        .getTableData(
          $http,
          ENV,
          $scope.table.options.endpoint,
          $scope.table.options.endpoint_data_key,
          parameters,
        )
        .then((res) => {
          $timeout(async () => {
            if ($scope.table.options.scale_up) {
              if (
                res.meta.count === 0 &&
                'timeframe' in parameters &&
                parameters.timeframe !== 'all' &&
                $scope.initialLoad
              ) {
                if (parameters.timeframe === 'day') {
                  await $scope.change_timeframe('week');
                } else if (parameters.timeframe === 'week') {
                  await $scope.change_timeframe('year');
                } else if (parameters.timeframe === 'year') {
                  await $scope.change_timeframe('all');
                }
                return $rootScope.getData();
              }
            }
            $scope.pageData = res;
            $scope.tableLoading = false;
            $scope.initialLoad = false;
            $scope.showMoreStatus = {};
            $scope.scrollToTop();
          });
        });
    };

    $rootScope.getDataByUrl = (url) => $scope.goToPage(url);

    $scope.goToPage = (url) => {
      $scope.tableLoading = true;
      $scope.pageData = {};
      $scope.records = [];
      $scope.getTableDataByUrl($http, url, $scope.table.options.endpoint_data_key).then((res) => {
        $timeout(async () => {
          $scope.pageData = res;
          $scope.tableLoading = false;
          $scope.showMoreStatus = {};
          $scope.scrollToTop();
        });
      });
    };

    $scope.validCustomValue = (filter_key, choice_key, key) => {
      const options = $scope.table.filters[filter_key];

      if (key === 'amount') {
        options.choices[choice_key].amount = options.choices[choice_key].amount.replace(
          /[^0-9\-]+/g,
          '',
        );
        if (
          options.choices[choice_key].amount === '' ||
          options.choices[choice_key].amount === null
        ) {
          return;
        }
      }
      if (key === 'range') {
        options.choices[choice_key].from = options.choices[choice_key].from.replace(
          /[^0-9\-]+/g,
          '',
        );
        options.choices[choice_key].to = $scope.table.filters[filter_key].options.choices[
          choice_key
        ].to.replace(/[^0-9\-]+/g, '');
      }
      if (key === 'date_range') {
        const { from, to } = $scope.table.filters[filter_key].options;
        options.from = from.replace(/[^0-9\-]+/g, '');
        options.to = to.replace(/[^0-9\-]+/g, '');
      }
    };

    $scope.validateFilters = () => {
      let isFilterValid = true;

      // eslint-disable-next-line no-restricted-syntax
      for (let filter of $scope.table.filters) {
        const { type, options } = filter;

        if (type === 'date_range') {
          const { from, to } = options;
          from.error = false;
          to.error = false;

          if (from.required && !from.value) {
            from.error = true;
          }

          if (to.required && !to.value) {
            to.error = true;
          }

          if (from.value && to.value) {
            const fromMoment = moment(from.value).valueOf();
            const toMoment = moment(to.value).valueOf();

            if (toMoment - fromMoment < 0) {
              from.error = true;
              to.error = true;
            }
          }

          if (from.error || to.error) {
            isFilterValid = false;
            break;
          }
        }
      }

      $scope.isFilterValid = isFilterValid;
    };

    $scope.clearText = async (filter_key, choice_key) => {
      await angular.forEach(
        $scope.table.filters[filter_key].options.choices,
        async (choice, key) => {
          if (key === choice_key) {
            $scope.table.filters[filter_key].options.choices[key].state = true;
          } else {
            $scope.table.filters[filter_key].options.choices[key].state = false;
            if ('error' in choice) {
              $scope.table.filters[filter_key].options.choices[key].error = false;
            }
            if ('amount' in choice) {
              $scope.table.filters[filter_key].options.choices[key].amount = '';
            }
            if ('from' in choice || 'to' in choice) {
              $scope.checkRangeErrors(
                filter_key,
                key,
                $scope.table.filters[filter_key].options.choices[key].date_field,
                false,
              );
            }
          }
        },
      );
    };

    $scope.switchSelectAll = (key, value) => {
      Object.values($scope.table.filters[key].options.choices).forEach((item) => {
        item.state = value;
        if ('options' in item) {
          Object.values(item.options).forEach((option) => {
            option.state = value;
          });
        }
      });
    };

    $scope.showPageOptions = () => {
      $scope.isPageOptions = !$scope.isPageOptions;
    };

    $scope.selectPageOption = (option) => {
      $scope.table.options.records_per_page = option;
    };

    $scope.showSortOptions = () => {
      $scope.isSortOptions = !$scope.isSortOptions;
    };

    $scope.selectSort = async (option_key, value) => {
      await angular.forEach($scope.table.sort_options, async (option, key) => {
        if (key === option_key) {
          $scope.table.sort_options[key].value = value;
          $scope.table.sort_options[key].state = true;
        }
      });
    };

    $scope.selectSortOptions = () => {
      $scope.isSortOptions = false;
    };

    $scope.showSortTitles = () => {
      return Object.values($scope.table.sort_options)
        .filter((item) => item.state === true)
        .map((item) => item.title)
        .join(', ');
    };

    $scope.getChoices = async () => {
      // if manager-users view load existsing filters
      if (
        $scope.tableInfo.filters &&
        $scope.tableInfo.filters.length > 0 &&
        $scope.isUserPageLoaded
      ) {
        $scope.table.filters = angular.copy($scope.tableInfo.filters);
      } else {
        await Promise.all(
          $scope.table.filters.map(async (value, key) => {
            if (
              (value.type === 'multiple_choice' || value.type === 'multi_level_multiple_choice') &&
              'choices_endpoint' in value.options
            ) {
              const choices = await $scope.getTableFilterOptions(
                $http,
                ENV,
                value.options.choices_endpoint,
                value.options.choices_endpoint_data_key,
              );
              if (choices && !!choices.length) {
                await choices.forEach((item) => {
                  const state =
                    ('default_choice' in value.options &&
                      item[value.options.name_attribute] === value.options.default_choice) ||
                    !('default_choice' in value.options);
                  $scope.table.filters[key].options.choices[item[value.options.name_attribute]] = {
                    state: state,
                    value: item.id,
                  };
                  if ('level' in value.options && value.options.level) {
                    $scope.table.filters[key].options.choices[
                      item[value.options.name_attribute]
                    ].options = angular.copy(value.options.level);
                  }
                });
              }
            }
          }),
        );
      }

      // if search term has been removed do not attempt to load previous options
      if ($scope.table.options.search_required && !$scope.searchTerm) {
        return;
      }
      // if search term exists attempt to load previous options
      if ($scope.isUserPageLoaded) {
        if ($scope.tableInfo.sort_options) {
          $scope.table.sort_options = angular.copy($scope.tableInfo.sort_options);
        }
        if ($scope.tableInfo.page_size) {
          $scope.table.options.records_per_page = $scope.tableInfo.page_size;
        }
        // if search term has not changed attempt to load previous results
        if (
          $scope.tableInfo.url &&
          $scope.tableInfo.search_term &&
          $scope.tableInfo.search_term === $rootScope.searchText
        ) {
          $scope.goToPage($scope.tableInfo.url);
          $scope.isUserPageLoaded = false;
          return;
        }
      }

      $rootScope.getData();
    };

    $scope.getRedemptionDetail = (index, redemption_id) => {
      $scope
        .getTableData($http, ENV, `/2.0/redemptions/${redemption_id}/`, 'redemptions', {})
        .then((res) => {
          $scope.$apply(async () => {
            $scope.pageData[$scope.table.options.endpoint_data_key][index].redemption =
              res.redemptions;
            $scope.pageData[$scope.table.options.endpoint_data_key][index].redemption.reward =
              res.redemptions.reward.description;
          });
        });
    };

    $scope.getTransactionDetail = (index, transaction_id) => {
      $scope
        .getTableData($http, ENV, `/2.0/transactions/${transaction_id}/`, 'transactions', {})
        .then((res) => {
          $scope.$apply(async () => {
            $scope.pageData[$scope.table.options.endpoint_data_key][index].transaction =
              res.transaction;
          });
        });
    };

    $scope.showMore = (index) => {
      $scope.showMoreStatus[index] = !$scope.showMoreStatus[index];
      // if (
      //   $scope.table.options.row_style === 'redemption' &&
      //   !('redemption' in $scope.pageData[$scope.table.options.endpoint_data_key][index])
      // ) {
      //   $scope.getRedemptionDetail(
      //     index,
      //     $scope.pageData[$scope.table.options.endpoint_data_key][index].id,
      //   );
      // } else if (
      //   $scope.table.options.row_style === 'activity' &&
      //   !('redemption' in $scope.pageData[$scope.table.options.endpoint_data_key][index]) &&
      //   !('transaction' in $scope.pageData[$scope.table.options.endpoint_data_key][index])
      // ) {
      //   if (
      //     $scope.pageData[$scope.table.options.endpoint_data_key][index].activity_type.includes(
      //       'Redemption',
      //     )
      //   ) {
      //     $scope.getRedemptionDetail(
      //       index,
      //       $scope.pageData[$scope.table.options.endpoint_data_key][index].redemption_id,
      //     );
      //   } else if (
      //     $scope.pageData[$scope.table.options.endpoint_data_key][index].activity_type.includes(
      //       'Transaction',
      //     )
      //   ) {
      //     $scope.getTransactionDetail(
      //       index,
      //       $scope.pageData[$scope.table.options.endpoint_data_key][index].transaction_id,
      //     );
      //   }
      // }
    };

    $scope.showTableActionMenu = () => {
      $scope.isTableActionMenu = !$scope.isTableActionMenu;
    };

    $scope.scrollToTop = () => {
      $('.container').scrollTop(0);
      $('.filter-panel').scrollTop(0);
    };

    $(document).on('click', (event) => {
      const pageOptionEle = $('.page-content');
      const sortOptionEle = $('.sort-content');
      const tableActionsEle = $('.table-actions-options');

      var $target = $(event.target);

      if (
        pageOptionEle !== event.target &&
        !$target.closest('.page-content').length &&
        !pageOptionEle.has(event.target).length
      ) {
        $scope.$apply(() => {
          $scope.isPageOptions = false;
        });
      }
      if (
        sortOptionEle !== event.target &&
        !$target.closest('.sort-content').length &&
        !sortOptionEle.has(event.target).length &&
        $scope.isSortOptions
      ) {
        $scope.$apply(() => {
          $scope.isSortOptions = false;
          $scope.selectSortOptions();
        });
      }
      if (
        tableActionsEle !== event.target &&
        !$target.closest('.table-actions-options').length &&
        !tableActionsEle.has(event.target).length &&
        $scope.isTableActionMenu
      ) {
        $scope.$apply(() => {
          $scope.isTableActionMenu = false;
        });
      }
    });

    $scope.$on('$routeChangeSuccess', ($event, current) => {
      if (current.$$route.originalPath === '/admin/users/manage-users') {
        $scope.isUserPageLoaded = true;
      } else {
        $scope.isUserPageLoaded = false;
      }
      if (
        current.$$route.originalPath &&
        !current.$$route.originalPath.includes('/admin/users/manage-users')
      ) {
        $scope.setTableDataInfo({
          url: null,
          key: null,
          filters: null,
          sort_options: null,
          search_term: null,
          page_size: 15,
        });
      }
    });

    $scope.init();

    $scope.$on('admin-overlay:ready', () => {
      if ($scope.subComponent) {
        $('.admin-overlay').css({ display: 'block' });
      } else {
        $('.admin-overlay').css({ display: 'none' });
      }
    });

    const searchEventListener = $rootScope.$on('searchEvent', (event, id) => {
      if ('search_key' in $scope.table.options && id === $scope.table.options.search_key) {
        $scope.searchTerm = $rootScope.searchText;
        $rootScope.searchText = null;
        $rootScope.getData();
      }
    });

    const viewContentListener = $scope.$watch('$viewContentLoaded', async () => {
      if ($rootScope.searchText !== null) {
        $scope.searchTerm = $rootScope.searchText;
      }
      $scope.checkTableActionsDisplay();
      $scope.getChoices();
      $scope.scrollToTop();
    });

    $scope.$on('$destroy', () => {
      $scope.unsubscribe();
      searchEventListener();
      viewContentListener();
    });
  })
  .directive('adminTable', () => {
    return {
      templateUrl: 'templates/v2/table.html',
    };
  });
